document.addEventListener('DOMContentLoaded', async function () {
    const is_showing = (await window.cookieStore.get('offer_popup_shown'))?.value === 'true';
    const offerPopup = document.getElementById('offer-section');
    const isEditor = offerPopup.hasAttribute('data-editor');
    
    if (!isEditor) {
        if (!is_showing) {
            setTimeout(() => {

                window.document.body.classList.add('offer-popup-active');
                offerPopup.style.display = 'flex';
                setTimeout(() => {
                    offerPopup.style.opacity = '1';
                    window.ProjectCardsCarousel.playAndPauseAll("playing");
                }, 100);
                window.cookieStore.set('offer_popup_shown', 'true');

                const closeButton = offerPopup.querySelector('#offer-close');
                closeButton.addEventListener('click', () => {
                    offerPopup.style.opacity = '0';
                    window.document.body.classList.remove('offer-popup-active');
                    window.ProjectCardsCarousel.playAndPauseAll("stopped");
                    setTimeout(() => {
                        offerPopup.style.display = 'none';
                    }, 500);

                });
            }, 5000);
        }
    }
});